import { cn } from "@/lib/utils";

const BASE_CLASS =
  "inline-flex select-none items-center justify-center gap-1 whitespace-nowrap font-medium leading-none rounded-md ring-1 ring-inset transition-colors [&_svg]:block [&_svg]:size-[1em] [&_svg]:shrink-0";

export type BadgeVariant =
  | "default"
  | "primary"
  | "success"
  | "warning"
  | "error"
  | "accent"
  | "outline";

export type BadgeSize = "sm" | "md" | "lg";

const VARIANT_CLASS: Record<BadgeVariant, string> = {
  default: "bg-surface-100 text-surface-700 ring-surface-500/15",
  primary: "bg-primary-50 text-primary-700 ring-primary-600/20",
  success: "bg-success-50 text-success-700 ring-success-600/20",
  warning: "bg-warning-50 text-warning-800 ring-warning-600/25",
  error: "bg-error-50 text-error-700 ring-error-600/20",
  accent: "bg-accent-50 text-accent-700 ring-accent-600/20",
  outline: "text-surface-600 bg-surface-0 ring-surface-300",
};

const SIZE_CLASS: Record<BadgeSize, string> = {
  sm: "h-5 px-1.5 text-[11px]",
  md: "h-[22px] px-2 text-xs",
  lg: "h-6 px-2.5 text-[13px]",
};

export function badgeVariants({
  variant = "default",
  size = "md",
  className,
}: {
  variant?: BadgeVariant;
  size?: BadgeSize;
  className?: string;
} = {}): string {
  return cn(BASE_CLASS, VARIANT_CLASS[variant], SIZE_CLASS[size], className);
}
